AccountableMixin   = require 'mixins/accountable'

App.ApiUser = DS.Model.extend AccountableMixin,
  account: DS.belongsTo 'account'

  isCourier:              Em.computed.equal('account.type', 'courier')
  isPartner:              Em.computed.equal('account.type', 'partner')
  isDispatcher:           Em.computed.equal('account.type', 'dispatcher')
  isStaffMember:          Em.computed.equal('account.type', 'staff_member')
  isLogisticsStaff:       Em.computed.equal('account.type', 'logistics_staff')


  # isLogisticsStaffAdmin:  (->
  #    @get('isLogisticsStaff') and @get('account.role') == 'admin'
  # ).property('isLogisticsStaff','account.role')
  # isLogisticsStaffManager:  (->
  #    @get('isLogisticsStaff') and @get('account.role') == 'manager'
  # ).property('isLogisticsStaff','account.role')

  # isLogisticsStaffManagerLogist:  (->
  #    @get('isLogisticsStaff') and @get('account.role') != 'manager' and @get('account.role') != 'manager'
  # ).property('isLogisticsStaff','account.role')

  stat: (scope, data) ->
    @nonRESTAction('POST', 'stat', {stat: {data: data, scope: scope}})
